import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
function PrivacyPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Privacy policy"} metaTitle={Host?.metaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  {t("Privacy policy")}
                </h1>

                <p>
                  This Privacy Policy explains how {Host?.domainName} LLC FZ  ("we", "our", or
                  "us") collects, uses, stores, and protects customer information when you visit or place an order
                  through {window.location.hostname}.
                </p>
                <p>
                  By using our website, creating an account, placing an order, contacting customer support, or using our
                  services, you agree to the collection and use of information in accordance with this Privacy Policy.
                </p>

                <h4>1. Information We Collect</h4>
                <p>We may collect the following information when you use our website or place an order:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• full name;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• email address;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• phone number;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• billing address;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• shipping address;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• order details;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • payment status and transaction confirmation details;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• delivery and tracking information;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• customer support messages;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • account login details, where applicable;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • device, browser, IP address, cookie, and usage information.
                </p>
                <p>
                  We do not store full credit card or debit card details on our servers. Online payments are processed
                  securely through third-party payment gateway providers.
                </p>

                <h4>2. How We Use Your Information</h4>
                <p>We use customer information to:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • process, confirm, and deliver orders;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • communicate order updates, delivery updates, OTP verification, and tracking information;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• provide customer support;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • process returns, refunds, cancellations, damaged item claims, defective item claims, and warranty
                  requests;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • verify payments and prevent fraud or unauthorized transactions;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • improve our website, products, services, and customer experience;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • send marketing communications, offers, or updates where permitted;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • comply with legal, regulatory, accounting, tax, and business record obligations;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • protect our rights, customers, website, and business operations.
                </p>

                <h4>3. Payment Information</h4>
                <p>Online payments are handled by trusted third-party payment gateway providers.</p>
                <p>We do not store full card numbers, CVV codes, or full banking details on our servers.</p>
                <p>
                  Payment providers may process payment information according to their own privacy policies and
                  applicable payment security standards.
                </p>

                <h4>4. Order Tracking and OTP Verification</h4>
                <p>
                  When customers use the order tracking feature, they may be asked to enter their order number and the
                  email address used when placing the order.
                </p>
                <p>
                  A one-time password (OTP) may be sent to the customer's email address to verify access before
                  displaying order status and tracking information.
                </p>
                <p>This helps protect order information from unauthorized access.</p>

                <h4>5. Cookies and Tracking Technologies</h4>
                <p>
                  We use cookies and similar technologies to operate our website, remember preferences, improve website
                  performance, understand customer behavior, and support marketing or advertising activities.
                </p>
                <p>Cookies may be used for:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• website functionality;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• account and cart features;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• security;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• analytics;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• advertising and remarketing;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• remembering customer preferences.</p>
                <p>
                  Customers may control or disable cookies through their browser settings. Some website features may not
                  work properly if cookies are disabled.
                </p>

                <h4>6. Marketing Communications</h4>
                <p>
                  We may use your email address or phone number to send promotional messages, offers, updates, or
                  newsletters where permitted.
                </p>
                <p>
                  You may opt out of marketing communications at any time by following the unsubscribe instructions in
                  the message or by contacting us at {Host?.email}.
                </p>
                <p>
                  Transactional messages related to orders, payments, delivery, refunds, OTP verification, or customer
                  support may still be sent where required to provide our services.
                </p>

                <h4>7. Sharing Information with Third Parties</h4>
                <p>
                  We may share customer information with trusted third parties only where necessary to operate our
                  business and provide our services, including:
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• payment gateway providers;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• courier and logistics partners;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • IT, hosting, and website service providers;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • analytics and marketing service providers;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• customer support tools;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• professional advisers;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • legal, regulatory, or government authorities where required by law.
                </p>
                <p>We do not sell customer personal information to third parties.</p>
                <p>
                  Third-party service providers are expected to use customer information only for the services they
                  provide to us.
                </p>

                <h4>8. Data Retention</h4>
                <p>We retain customer information for as long as reasonably necessary to:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• process and manage orders;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• provide customer support;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • handle returns, refunds, cancellations, and warranty claims;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • comply with legal, tax, accounting, and regulatory obligations;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• resolve disputes;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • prevent fraud and protect our business.
                </p>
                <p>
                  When information is no longer required, we will delete, anonymize, or securely retain it in accordance
                  with applicable law and business requirements.
                </p>

                <h4>9. Data Security</h4>
                <p>
                  We use reasonable technical and organizational measures to protect customer information, including
                  secure website connections, restricted access, and secure payment processing through third-party
                  payment providers.
                </p>
                <p>
                  However, no method of internet transmission or electronic storage is completely secure. While we work
                  to protect customer information, we cannot guarantee absolute security.
                </p>

                <h4>10. International Transfers</h4>
                <p>
                  Customer information may be processed or stored in the United Arab Emirates or other countries where
                  our service providers operate.
                </p>
                <p>
                  Where information is transferred outside the customer's country of residence, we take reasonable steps
                  to ensure that it is protected in accordance with this Privacy Policy and applicable law.
                </p>

                <h4>11. Customer Rights</h4>
                <p>Customers may contact us to request:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • access to personal information we hold about them;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • correction of inaccurate or incomplete information;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • deletion of personal information, where applicable;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • withdrawal from marketing communications;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • information about how their data is used.
                </p>
                <p>We may need to verify your identity before responding to certain requests.</p>
                <p>
                  Some information may need to be retained where required for legal, tax, accounting, fraud prevention,
                  order processing, dispute resolution, or regulatory purposes.
                </p>

                <h4>12. Children's Privacy</h4>
                <p>Our website and services are not intended for children under the age of 18.</p>
                <p>
                  We do not knowingly collect personal information from children under 18. If we become aware that
                  personal information has been collected from a child without appropriate consent, we will take
                  reasonable steps to delete it.
                </p>

                <h4>13. Links to Third-Party Websites</h4>
                <p>
                  Our website may contain links to third-party websites or services that are not operated by{" "}
                  {Host?.domainName}.
                </p>
                <p>
                  We are not responsible for the privacy practices, content, or policies of third-party websites.
                  Customers are encouraged to review the privacy policies of any third-party websites they visit.
                </p>

                <h4>14. Changes to This Privacy Policy</h4>
                <p>
                  We may update this Privacy Policy from time to time by posting the updated version on our website.
                </p>
                <p>The updated Privacy Policy will apply from the date it is posted, unless stated otherwise.</p>
                <p>Customers are encouraged to review this page periodically.</p>

                <h4>15. Contact Us</h4>
                <p>For questions about this Privacy Policy or how your information is handled, please contact us:</p>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                </p>
                <p>Customer Support: 8:00 AM to 10:00 PM Dubai Time, 7 days a week</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
